<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction padding-bottom-4">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block margin-xl-top-5">
              <p class="mb-0 text-size-14 text-uppercase nav-color fw-bold inter-bold-family text-full-13">
                We love pets
              </p>
              <h1 class="text-black fw-bold text-full-28 filson-black-family margin-bottom-3 w-70 w-xs-100 w-sm-100 w-md-100 w-ipad-100">
                We will make your pet happy
              </h1>
              <p class="text-black text-size-14 family-inter-light w-85 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-4 text-full-13">
                We believe that a happy pet leads to a happy owner, and we take pride in the bonds we build with both our four-legged clients and their human companions. So, whether it’s for daycare, boarding, grooming, or any other
                pet-related services, you can trust us to go the extra mile to make your pet happy and content while they are with us. Your pet’s well-being is our top priority, and we look forward to becoming your furry friend’s second
                home.
              </p>
            </div>
          </div>
          <div class="col-xl-6 col-12 mt-2 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block about-banner-dog-image">
              <img class="w-100" src="@/assets/images/grooming-services-pet-grooming-equipment-mobile-grooming-service.webp" alt="grooming services, pet grooming equipment, mobile grooming service" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-about-banner">
      <div class="container autoContent">
        <div class="row pt-xl-5 pt-4 pb-xl-5 pb-4">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6 mt-xl-4 mb-xl-4">
            <div class="w-100 d-inline-block pets-image-under-progressbar position-relative">
              <img class="w-100 rounded-4 men-pets-image" src="@/assets/images/pet-grooming-at-home-pet-grooming-tools-pet-groming-salon.webp" alt="pet grooming at home, pet grooming tools, pet groming salon" />
              <div class="d-inline-block rounded-3 bg-introduction padding-3 progreebar-box position-absolute w-70 w-xs-100 w-sm-100 w-md-100 w-ipad-100">
                <div class="row">
                  <div class="col-2 margin-top-2">
                    <img class="progressbar-icon-image" src="@/assets/images/progressbar-icon-image.png" alt="picture" />
                  </div>
                  <div class="col-10">
                    <div class="w-100 d-inline-block progreebar-green">
                      <label class="w-100 d-inline-block text-black text-size-13 inter-bold-family text-full-11">
                      Pets Care
                      </label>
                      <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar bg-green w-85 text-full-11 text-size-12">85%</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row margin-top-2">
                  <div class="col-2 margin-top-2">
                    <img class="progressbar-icon-image" src="@/assets/images/progressbar-icon-image-2.png" alt="picture" />
                  </div>
                  <div class="col-10">
                    <div class="w-100 d-inline-block progreebar-green">
                      <label class="w-100 d-inline-block text-black text-size-13 inter-bold-family text-full-11">
                      Pet Grooming
                      </label>
                      <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar bg-blue w-70 text-full-11 text-size-12">70%</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row margin-top-2">
                  <div class="col-2 margin-top-2">
                    <img class="progressbar-icon-image" src="@/assets/images/progressbar-icon-image-3.png" alt="picture" />
                  </div>
                  <div class="col-10">
                    <div class="w-100 d-inline-block progreebar-green">
                      <label class="w-100 d-inline-block text-black text-size-13 inter-bold-family text-full-11">
                      Experienced Staff
                      </label>
                      <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar bg-black w-60 text-full-11 text-size-12">60%</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6 margin-xl-top-3">
            <div class="w-100 d-inline-block margin-top-4 padding-xl-left-5">
              <div class="w-100 d-inline-block padding-xl-left-5 mt-xl-0 mt-5">
                <h2 class="text-black fw-bold filson-black-family text-full-28 text-xs-size-20">
                  Why You Should Choose Us
                </h2>
                <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                  Choosing us for your pets grooming needs is the best decision you can make for the well-being and happiness of your furry companions. At Pets Grooming, we pride ourselves on offering a personalized and caring experience
                  that goes beyond a simple grooming session. Here are some compelling reasons why you should choose us
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-white padding-top-4 padding-bottom-4">
      <div class="container autoContent">
        <div class="row">
          <div class="col-12 text-center margin-bottom-2 mt-xl-0 mt-0 mt-md-5">
            <h2 class="text-black fw-bold filson-black-family text-full-28 text-xs-size-20">What Our Customers Say
            </h2>
            <p class="text-size-14 text-black family-inter-light text-full-13">
              Here's what our happy customers are saying.
            </p>
          </div>
        </div>
        <div class="w-100 d-inline-block review-slider bg-introduction position-relative padding-4 rounded-3">
          <a class="position-absolute comas-icon" href="javascript:void(0)">
          <img src="@/assets/images/comas-icon.png" alt="picture">
          </a>
          <div class="row">
            <div class="col-12">
                <div class="carousel-wrapper">
                  <div class="carousel" ref="carousel">
                    <div class="w-100 d-inline-block margin-right-2" v-for="(review, index) in displayReviews" :key="index">
              <div class="w-100 w-100 rounded-2 padding-3 
              bg-black">
                <div class="d-flex align-items-center margin-bottom-2">
                  <img
                    :src="review.profile_photo_url"
                    alt="Profile"
                    class="rounded-circle margin-right-2 customer-review-image"
                    />
                  <div class="d-inline-block w-70">
                    <p class="mb-0 text-white text-size-14 text-full-14 family-inter-light">{{ review.name }}</p>
                    <small class="strike-text text-size-13 family-inter-light text-full-13">{{ review.date }}</small>
                  </div>
                  <div class="d-inline-block google-icon-image">
                    <img src="@/assets/images/google-icon-image.svg" alt="picture">
                  </div>
                </div>
                <div class="w-100 d-inline-block margin-bottom-2">
                  <span v-for="star in 5" :key="star">
                  <i
                    class="fa"
                    :class="star <= review.rating ? 'fa-star text-warning' : 'fa-star-o text-secondary'"
                    ></i>
                  </span>
                </div>
                <p class="mb-0 text-white text-size-13 text-full-13 family-inter-light review-text">{{ review.text }}</p>
              </div>
            </div>
                  </div>
                  <div class="flex justify-between mt-4">
                    <button class="border-0 position-absolute angle-left" @click="changeSlide(-1)">
                      <i class="fa fa-angle-left text-white text-full-24 text-size-24" aria-hidden="true"></i>
                    </button>
                    <button class="border-0 position-absolute angle-right" @click="changeSlide(1)">
                      <i class="fa fa-angle-right text-white text-full-24 text-size-24" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-4 margin-bottom-4">
          <div class="col-xl-4 col-12 col-sm-6 col-md-6 col-lg-4 mt-xl-0 mt-0 mt-md-3">
            <div class="row">
              <div class="col-xl-2 pe-xl-0 text-center col-3">
                <img class="height-40" src="@/assets/images/clander-icon.png" alt="picture" />
              </div>
              <div class="col-xl-10 col-9">
                <p class="mb-0 text-size-16 text-black fw-bold filson-black-family line-height-20 text-full-16">
                  5000+
                </p>
                <p class="mb-0 text-size-16 text-black fw-bold filson-black-family text-full-16">
                  Total Appointments
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-12 col-sm-6 col-md-6 col-lg-4">
            <div class="row mt-3 mt-xl-0">
              <div class="col-xl-2 col-3 pe-xl-0 text-center">
                <img class="height-45" src="@/assets/images/clander-icon-2.png" alt="picture" />
              </div>
              <div class="col-xl-10 col-9">
                <p class="mb-0 text-size-16 text-black fw-bold filson-black-family line-height-20 text-full-16">
                  5 Years of
                </p>
                <p class="mb-0 text-size-16 text-black fw-bold filson-black-family text-full-16">
                  Grooming Experience
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-12 col-sm-6 col-md-6 col-lg-4">
            <div class="row mt-xl-0 mt-3">
              <div class="col-xl-2 col-3 pe-xl-0 text-center">
                <img class="height-45" src="@/assets/images/clander-icon-3.png" alt="picture" />
              </div>
              <div class="col-xl-10 col-9">
                <p class="mb-0 text-size-16 text-black fw-bold filson-black-family line-height-20 text-full-16">
                  5000+
                </p>
                <p class="mb-0 text-size-16 text-black fw-bold filson-black-family text-full-16">
                  Happy Customers
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
      bg-orange">
      <div class="container autoContent">
        <div class="row margin-top-1 margin-bottom-0">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                <i class="fa fa-home nav-color" aria-hidden="true"></i>
                Home  /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "aboutUsBannerComponent",
    data() {
     return {
       reviews: [],
       staticReviews: [
        {
          name: 'Sarah M.',
          date: 'March 2024',
          profile_photo_url: 'https://ui-avatars.com/api/?name=Sarah+M&background=F47B20&color=fff&size=64',
          rating: 5,
          text: 'Amazing service! My golden retriever looks absolutely fantastic after his grooming session. The team was so gentle and professional. Highly recommended!'
        },
        {
          name: 'Ahmed K.',
          date: 'February 2024',
          profile_photo_url: 'https://ui-avatars.com/api/?name=Ahmed+K&background=F47B20&color=fff&size=64',
          rating: 5,
          text: 'Best mobile grooming service in Dubai! They came right to our doorstep and my cat was completely stress-free. Will definitely book again.'
        },
        {
          name: 'Priya R.',
          date: 'January 2024',
          profile_photo_url: 'https://ui-avatars.com/api/?name=Priya+R&background=F47B20&color=fff&size=64',
          rating: 5,
          text: 'Wonderful experience! My rabbit was in great hands. The groomers were very knowledgeable and caring. The convenience of having them come home is unbeatable.'
        },
        {
          name: 'James T.',
          date: 'December 2023',
          profile_photo_url: 'https://ui-avatars.com/api/?name=James+T&background=F47B20&color=fff&size=64',
          rating: 5,
          text: 'Exceptional bird grooming service. My parrot has never looked better! Very professional team who clearly know and love animals.'
        },
       ],
     };
    },
    computed: {
      displayReviews() {
        return this.reviews.length > 0 ? this.reviews : this.staticReviews;
      },
    },
    mounted() {
      const name = (this.$countryName || '').toString().trim();
      if (name) {
        this.staticReviews = this.staticReviews.map((r) => ({
          ...r,
          text: String(r.text || '').replace(/dubai/gi, name),
        }));
      }
      this.fetchGoogleReviews();
    },
   methods: {
    changeSlide(delta) {
      const carousel = this.$refs.carousel;
      const width = carousel.offsetWidth;
      const scrollLeft = carousel.scrollLeft;
      carousel.scrollLeft = scrollLeft + width * delta;
    },
    goTo(number) {
     const scrollTarget = this.$refs.carousel.children[number];
     this.$refs.carousel.scrollLeft = scrollTarget.offsetLeft;
    },
    async fetchGoogleReviews() {
      try {
        const response = await this.$axios.post('/get-google-reviews', {
          website_name: this.activeWebsiteName,
        });
        if (response.data.status === "success" && response.data.reviews && response.data.reviews.length > 0) {
          this.reviews = response.data.reviews;
        }
      } catch (error) {
        console.error('Error fetching Google reviews:', error);
      }
    },
   },
  };
</script>
<style scoped>
  .fa-star,
  .fa-star-o {
  font-size: 16px;
  }
</style>